<app-page-meta pageTitle="finzy - Signed Loan Documents"></app-page-meta>

<div class="container-fluid">
  <div class="row">
    <div class="col-xs-12">

      <div class="row finzy-row5">
        <p class="finzy-t1">Signed Documents</p>

        <div class="row finzy-row10">

          <div class="row finzy-row10gray" *ngIf="nodoc">
            <p class="greydivp1"><i class="material-icons" style="font-size: 90px;color: #757575;">thumb_up</i></p>
            <p class="greydivp">You are all set!</p>
            <p class="greydivp">There are no signed documents</p>
          </div>

          <div class="row finzy-row3" *ngIf="contractexists">
            <div class="col-sm-8">
              <div class="row">
                <div class="col-sm-2"><span class="downloadImg"><i class="fa fa-file-text-o"
                                                                   aria-hidden="true"></i></span></div>
                <div class="col-sm-10">
                  <p class="finzy-p71">Contract</p>
                  <p class="finzy-p81">For Loan : {{loan_id}}</p>
                </div>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="downloadDiv">
                <a href="javascript:void(0);"  (click)="openFromMobile(contract,true)" class="downloadanc"><p class="download"><i
                  class="material-icons downloadmat">file_download</i></p>
                  <p class="finzy-proi2">&nbsp;&nbsp; DOWNLOAD</p></a>
              </div>
            </div>
          </div>

          <div class="row finzy-row3" *ngIf="dpnexists">
            <div class="col-sm-8">
              <div class="row">
                <div class="col-sm-2"><span class="downloadImg"><i class="fa fa-file-text-o"
                                                                   aria-hidden="true"></i></span></div>
                <div class="col-sm-10">
                  <p class="finzy-p71">Demand Promissory Note</p>
                  <p class="finzy-p81">For Loan : {{loan_id}}</p>
                </div>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="downloadDiv">
                <a href="javascript:void(0);" (click)="openFromMobile(dpn,true)" class="downloadanc"><p class="download"><i
                  class="material-icons downloadmat">file_download</i></p>
                  <p class="finzy-proi2">&nbsp;&nbsp; DOWNLOAD</p></a>
              </div>
            </div>
          </div>

          <div class="row finzy-row3" *ngIf="pdfexists">
            <div class="col-sm-8">
              <div class="row">
                <div class="col-sm-2"><span class="downloadImg"><i class="fa fa-file-text-o"
                                                                   aria-hidden="true"></i></span></div>
                <div class="col-sm-10">
                  <p class="finzy-p71">Partner Declaration Form</p>
                  <p class="finzy-p81">For Loan : {{loan_id}}</p>
                </div>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="downloadDiv">
                <a href="javascript:void(0);" (click)="openFromMobile(pdf,true)" lass="downloadanc"><p class="download"><i
                  class="material-icons downloadmat">file_download</i></p>
                  <p class="finzy-proi2">&nbsp;&nbsp; DOWNLOAD</p></a>
              </div>
            </div>
          </div>

          <div class="row finzy-row3" *ngIf="nachexists">
            <div class="col-sm-8">
              <div class="row">
                <div class="col-sm-2"><span class="downloadImg"><i class="fa fa-file-text-o"
                                                                   aria-hidden="true"></i></span></div>
                <div class="col-sm-10">
                  <p class="finzy-p71">NACH mandate</p>
                  <p class="finzy-p81">For Loan : {{loan_id}}</p>
                </div>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="downloadDiv">
                <a href="javascript:void(0);" (click)="openFromMobile(nach,true)" class="downloadanc"><p class="download"><i
                  class="material-icons downloadmat">file_download</i></p>
                  <p class="finzy-proi2">&nbsp;&nbsp; DOWNLOAD</p></a>
              </div>
            </div>
          </div>


        </div>

      </div>

      <div class="row finzy-row4">
        <p class="finzy-p6" *ngIf="otherDomain">If you need assistance you can find help here <a target="_blank"
                                                                                                 [routerLink]="['/partnerfaq']"
                                                                                                 class="finzy-col">FAQs</a>.
          You could even call us on 9341 800 800. We are always happy to help!</p>

        <p class="finzy-p6" *ngIf="finzyDomain">If you need assistance you can find help here <a target="_blank"
                                                                                                 [routerLink]="['/faq']"
                                                                                                 class="finzy-col">FAQs</a>.
          You could even call us on 9341 300 300. We are always happy to help!</p>
      </div>

    </div>
  </div>
</div>
